export const URL_COUNTRY = "/api/v1/country";
export const URL_TOUR = "/api/v1/tour";
